/**
 * REV-22155 — one row of the persons overview, ready to show (the page builds it from `IPersonDTO`,
 * the users and the tags; the `persons-overview` pure view only displays it).
 */
export interface IPersonOverviewRow {
    _id: string;
    /** "Nachname Vorname". */
    name: string;
    street: string;
    zip: string;
    city: string;
    /** Names of the tags; ids of deleted tags are already left out. */
    tagNames: string[];
    assigneeId: string | null;
    assigneeName: string;
    clerkId: string | null;
    clerkName: string;
}
